import React, { useState } from "react";
import axios from "axios";
import formatDate from "../utils/DateFormatter";
import loaderGif from "./../assets/loader.gif";
import { BsDownload } from "react-icons/bs";

const API_BASE = "https://nodeapi.smartdietplanner.com/api/profile"; // change to your API

export default function UserProfileExport({companyId}) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isCompleted, setIsCompleted] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setError("");

    try {
      const params = {
        companyId,
      };

      if (startDate && endDate) {
        params.startDate = new Date(startDate).toISOString();
        params.endDate = new Date(endDate).toISOString();
      }

      if (isCompleted !== "") {
        params.isCompleted = isCompleted;
      }

      console.log("Params:: ", params);

      const data = await axios.get(`${API_BASE}/getAll`, { params });

      if (!data || !data.data || data.data.length === 0) {
         alert("No data available to download.");
         return;
      }

      const headers = [
         "id",
         "name",
         "age",
         "weight",
         "height",
         "bmi",
         "disorders",
         "community",
         "diet_plan",
         "profile_completed",
         "creation_date",
      ];

      const rows = data.data.data.map((item) => ({
         id: item._id || "",
         name: item.profile?.name || "",
         age: item.demographic?.age?.avg_age || "",
         weight: item.demographic?.weight?.value + " kg" || "",
         height:
         item.demographic?.height?.value +
            " " +
            item.demographic?.height?.unit || "",
         bmi: item.demographic?.bmi || "",
         disorders: (item.lifeStyle?.diseases || []).join(", "),
         community: (item.lifeStyle?.communities || []).join(", "),
         diet_plan: item.lifeStyle?.dietPlanName || "",
         profile_completed: !!(
         item.lifeStyle?.bmr
         ),
         dietitian_name: item.assignedDietitan?.dietitianName,
         creation_date: formatDate(item.profile?.createdDate) || "",
      }));

      const csvContent = headers.join(",") +  "\n" +
         rows.map((row) => headers.map((h) => `"${row[h]}"`).join(",")).join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>User Download</h2>

      <div style={styles.row}>

         <div style={styles.row2}>
            <label>Start Date:</label>
            <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={styles.input}
            />
         </div>

         <div style={styles.row2}>
            <label>End Date:</label>
            <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={styles.input}
            />
         </div>
      </div>

      <div style={styles.row}>

         <label>Status:</label>

         <label style={styles.row2}>
         <input
            type="radio"
            name="status"
            value=""
            checked={isCompleted === ""}
            onChange={() => setIsCompleted("")}
         />
         All
         </label>

         <label style={styles.row2}>
         <input
            type="radio"
            name="status"
            value="true"
            checked={isCompleted === "true"}
            onChange={() => setIsCompleted("true")}
         />
         Completed
         </label>

         <label style={styles.row2}>
         <input
            type="radio"
            name="status"
            value="false"
            checked={isCompleted === "false"}
            onChange={() => setIsCompleted("false")}
         />
         Uncompleted
         </label>
      </div>

      <button onClick={fetchData} style={styles.button} disabled={startDate==="" || endDate===""}>
         {loading ? (
         <img src={loaderGif} alt="loader" className="w-10 mx-auto" />
      ) : (<> <BsDownload /> Fetch Records</>) }
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

const styles = {
  container: {
   padding: "1rem",
   border: "#000 2px solid",
   margin: "2.5rem",
   display: "flex",
   flexDirection: "column",
   justifyContent: "center",
   alignItems: "center"
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "1.25rem", 
   lineHeight: "1.75rem",
   fontWeight: "600",
   textDecorationLine: "underline"
  },
  row: {
    display: "flex",
    marginBottom: "10px",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: "40%"
  },
  row2: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  input: {
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "0.5rem 20px",
    borderRadius: "50px",
    border: "none",
    background:  "#93C5FD",
    color: "#000",
    fontSize: "1.125rem",
    lineHeight: "1.75rem", 
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.75rem",
    minWidth: "200px"
  },
  tableContainer: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff",
  },
};